"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnePerJoule = exports.OnePerMegajoule = exports.OnePerKilojoule = exports.OnePerTherm = exports.OnePerMegaBtu = exports.OnePerBtu = exports.OnePerKiloWattHour = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var energy_1 = require("./energy");
var energy2_1 = require("./energy2");
/// http://www.wolframalpha.com/input/?i=BTU and select 'Show exact conversions'
// Per Energy
exports.OnePerKiloWattHour = UnitDivide.dimensionlessByEnergy("OnePerKiloWattHour", uom_1.Unit.One, energy2_1.KiloWattHour);
exports.OnePerBtu = UnitDivide.dimensionlessByEnergy("OnePerBtu", uom_1.Unit.One, energy_1.Btu);
exports.OnePerMegaBtu = UnitDivide.dimensionlessByEnergy("OnePerMegaBtu", uom_1.Unit.One, energy_1.MegaBtu);
exports.OnePerTherm = UnitDivide.dimensionlessByEnergy("OnePerTherm", uom_1.Unit.One, energy_1.Therm);
exports.OnePerKilojoule = UnitDivide.dimensionlessByEnergy("OnePerKilojoule", uom_1.Unit.One, energy_1.Kilojoule);
exports.OnePerMegajoule = UnitDivide.dimensionlessByEnergy("OnePerMegajoule", uom_1.Unit.One, energy_1.Megajoule);
exports.OnePerJoule = UnitDivide.dimensionlessByEnergy("OnePerJoule", uom_1.Unit.One, energy_1.Joule);
//# sourceMappingURL=dimensionless-per-energy.js.map